import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as actions from './actions'

export const usePositions = () => {
    const {
        refresh,
        initialize,
        positions = [],
    } = useSelector((state) => state.position);

    const dispatch = useDispatch();

    const setRefreshPositions = useCallback(
        (payload) => dispatch(actions.setRefreshPositions(payload)),
        [dispatch]
    );

    const setPositions = useCallback(
        (payload) => dispatch(actions.setPositions(payload)),
        [dispatch]
    );

    const addPositions = useCallback(
        (payload) => dispatch(actions.addPositions(payload)),
        [dispatch]
    );

    return {
        refresh,
        initialize,
        positions,
        setRefreshPositions,
        setPositions,
        addPositions
    };
} 